module.exports = __webpack_public_path__ + "img/logo-XPO.462a914c.svg";